
import {
  defineAsyncComponent, defineComponent, PropType, SetupContext,
} from 'vue';
import { ArrowLeftOutlined, CheckCircleOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  components: {
    bIcon: defineAsyncComponent(() => import('@/components/BaseIcon.vue')),
    ArrowLeftOutlined,
    CheckCircleOutlined,
  },
  props: {
    /** preview预览、see查看、submit做题 */
    view: {
      type: String as PropType<'preview'|'see'|'submit'>,
      required: true,
    },
    /** 案例名 */
    name: {
      type: String,
      required: true,
    },
  },
  emits: ['on-back', 'on-submit'],
  setup(this, props, ctx: SetupContext) {
    const handleBack = () => {
      ctx.emit('on-back');
    };
    const handleSubmit = () => {
      ctx.emit('on-submit');
    };
    return {
      handleBack,
      handleSubmit,
    };
  },
});
